import { Inject } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA, MatDialog } from '@angular/material';
import { ToastrManager } from 'ng6-toastr-notifications';
import { DatabaseService } from 'src/_services/DatabaseService';
import * as moment from 'moment';




@Component({
  selector: 'app-bottom-sheet',
  templateUrl: './bottom-sheet.component.html'
})
export class BottomSheetComponent implements OnInit {
  search: any = {};
  today_date: any = new Date();
  lastPageData: any = {}
  monthlyWorkReport: any = []
  distributorsList: any = []
  eventUser: any;
  savingFlag:boolean=false;


  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: any,public dialog: MatDialog, public service: DatabaseService, private bottomSheetRef: MatBottomSheetRef<BottomSheetComponent>, public toast: ToastrManager) {
    this.lastPageData = data;
    console.log(this.lastPageData);
    if (this.lastPageData.filterPage == 'expense_claim_date' || this.lastPageData.filterPage == 'expense_date_created') {
      this.search.filterPage = this.lastPageData.filterPage;
      this.getSalesUser('');
    }
    if (this.lastPageData.filterPage == 'product_wise_secondary_report' || this.lastPageData.filterPage == 'userWorkReport' || this.lastPageData.filterPage == 'checkin_list' || this.lastPageData.filterPage == 'attendence_list' || this.lastPageData.filterPage == 'task_list') {
      this.getSalesUser('');
    }
    if (this.lastPageData.filterPage == 'Event') {
      this.getEventUser('');
    }

  }

  ngOnInit() {
  }
  public date(date) {
    if (this.search.date_from) {
      this.search.date_from = moment(this.search.date_from).format('YYYY-MM-DD');

    }
    if (this.search.date_to) {
      this.search.date_to = moment(this.search.date_to).format('YYYY-MM-DD');

    }
  }
  salesUser: any = [];
  getSalesUser(searchValue) {
    this.service.post_rqst({ 'search': searchValue }, "Expense/salesUserList").subscribe((response => {
      if (response['statusCode'] == 200) {
        this.salesUser = response['all_sales_user'];
        if (this.lastPageData.filterPage == 'expense_claim_date' || this.lastPageData.filterPage == 'expense_date_created' || this.lastPageData.filterPage == 'product_wise_secondary_report') {
          this.salesUser.unshift({ 'id': 'All', 'name': 'All', 'role_name': '' })
        }
      } else {
        this.toast.errorToastr(response['statusMsg']);
      }
    }));
  }

  getEventUser(searchValue) {
    this.service.post_rqst({ 'sendData': searchValue }, "Event/eventList").subscribe((response => {
      if (response['statusCode'] == 200) {
        this.eventUser = response['all_sales_user'];
      }
    }))
  }

  getValue() {
    this.bottomSheetRef.dismiss(this.search);
  }


  selectAll2(action) {
    if (action == 'allSaleUsers') {
      setTimeout(() => {
        if (this.search.allSaleUsers == true) {
          const productData = [];
          for (let i = 0; i < this.salesUser.length; i++) {
            productData.push(this.salesUser[i].id)
          }

          this.search.user_id = productData;

        } else {
          this.search.user_id = [];
        }
      }, 1000);
    }
  }

  selectAllEmployees(action) {
    if (action == 'allemployees') {
      if (this.search.allemployees == true) {
        const employeeData = [];
        for (let i = 0; i < this.salesUser.length; i++) {
          employeeData.push(this.salesUser[i].id)
        }
        this.search.user_id = employeeData;
      } else {
        this.search.user_id = [];
      }
    }
  }

  getDistributors(type, search) {
    this.service.post_rqst({ 'Type': type, 'search': search }, "Reports/customerNetworkList").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.distributorsList = result['result'];
      } else {
        this.toast.errorToastr(result['statusMsg']);
      }
    }))
  }





}
